import { useEffect, useRef } from "react";

export function useJsonLd(jsonLd: Record<string, unknown> | null): void {
  const scriptRef = useRef<HTMLScriptElement | null>(null);

  useEffect(() => {
    if (!jsonLd) return;

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);
    scriptRef.current = script;

    return () => {
      if (scriptRef.current && scriptRef.current.parentNode) {
        scriptRef.current.parentNode.removeChild(scriptRef.current);
        scriptRef.current = null;
      }
    };
  }, [jsonLd]);
}